import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const RateCardHeaderModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=Vk1ApGmZZ28&feature=youtu.be&ab_channel=apadua" />
);

export default RateCardHeaderModal;
